/**
 * Cores padronizadas para métricas de impacto ambiental
 * Usado em todos os gráficos e KPIs da página de Dados de Impacto
 * para garantir consistência visual
 */

export const IMPACT_METRIC_COLORS = {
  // Métricas principais
  co2: '#16A34A',        // Verde - CO₂ evitado
  energy: '#F59E0B',     // Âmbar/Amarelo - Energia gerada
  recovered: '#0D9488',  // Teal - Material recuperado
  landfill: '#6B7280',   // Cinza - Aterro evitado
  km: '#14B8A6',         // Teal claro - Km equivalentes
  
  // Alias para uso em gráficos com nomenclatura diferente
  energia: '#F59E0B',    // Alias para energy
  material: '#0D9488',   // Alias para recovered
  aterro: '#6B7280',     // Alias para landfill
} as const;

// Labels padronizados para métricas
export const IMPACT_METRIC_LABELS = {
  co2: 'CO₂ evitado (kg)',
  energy: 'Energia gerada (kWh)',
  energia: 'Energia gerada (kWh)',
  recovered: 'Material recuperado (kg)',
  material: 'Material recuperado (kg)',
  landfill: 'Aterro evitado (m³)',
  aterro: 'Aterro evitado (m³)',
  km: 'Km equivalentes',
} as const;

// Função helper para obter cor de métrica
export const getImpactMetricColor = (metricKey: string): string => {
  return IMPACT_METRIC_COLORS[metricKey as keyof typeof IMPACT_METRIC_COLORS] || '#10B981';
};

// Função helper para obter label de métrica
export const getImpactMetricLabel = (metricKey: string): string => {
  return IMPACT_METRIC_LABELS[metricKey as keyof typeof IMPACT_METRIC_LABELS] || metricKey;
};

// Paleta de cores para gráfico de distribuição por material (Indicadores Ambientais)
export const MATERIAL_COLORS: Record<string, string> = {
  'Papel':             '#E9C46A',
  'Papelão':           '#E9C46A',
  'Papel/Papelão':     '#E9C46A',
  'Papel / Papelão':   '#E9C46A',
  'Plástico':          '#EF4444',
  'Vidro':             '#93C5FD',
  'Metal':             '#1D3461',
  'Aço/Ferro':         '#1D3461',
  'Aço / Ferro':       '#1D3461',
  'Alumínio':          '#F97316',
  'Orgânicos':         '#16a34a',
  'Óleo':              '#8B5CF6',
  'RCC':               '#A78BFA',
  'Rejeitos':          '#6B7280',
  'Outros':            '#9CA3AF',
};

export function getMaterialColor(material: string): string {
  return MATERIAL_COLORS[material] ?? MATERIAL_COLORS['Outros'];
}
